const onClickConnect = async () => {
  try {
    await window.ethereum.request({ method: "eth_requestAccounts" });
  } catch (error) {
    console.error(error); // output an error as a popup
  }
};

export default onClickConnect;
